export var IconNames;
(function (IconNames) {
    IconNames["Alert1"] = "alert1";
    IconNames["Alert2"] = "alert2";
    IconNames["Archive"] = "archive";
    IconNames["Arrow"] = "arrow";
    IconNames["BadgeCheck"] = "badge-check";
    IconNames["BadgeLost"] = "badge-lost";
    IconNames["BadgePlus"] = "badge-plus";
    IconNames["BadgeX"] = "badge-x";
    IconNames["Badge"] = "badge";
    IconNames["Badges"] = "badges";
    IconNames["BarGraph"] = "bar-graph";
    IconNames["Bellhop"] = "bellhop";
    IconNames["Billing"] = "billing";
    IconNames["Bookmark"] = "bookmark";
    IconNames["CalendarPlus"] = "calendar-plus";
    IconNames["CalendarX"] = "calendar-x";
    IconNames["Calendar"] = "calendar";
    IconNames["Caret"] = "caret";
    IconNames["Case"] = "case";
    IconNames["Checkmark"] = "checkmark";
    IconNames["Chevron"] = "chevron";
    IconNames["ChevronPrev"] = "chevron-prev";
    IconNames["ChevronNext"] = "chevron-next";
    IconNames["Close"] = "close";
    IconNames["Columns"] = "columns";
    IconNames["Connect"] = "connect";
    IconNames["Cost"] = "cost";
    IconNames["CrossConnect"] = "cross-connect";
    IconNames["SwitchBoardPort"] = "switch-board-port";
    IconNames["PowerCircuit"] = "power-circuit";
    IconNames["Dash"] = "dash";
    IconNames["Delete"] = "delete";
    IconNames["Demo"] = "demo";
    IconNames["Drag"] = "drag";
    IconNames["Drop"] = "drop";
    IconNames["Duplicate"] = "duplicate";
    IconNames["Edit"] = "edit";
    IconNames["Email"] = "email";
    IconNames["EquipmentRemove"] = "equipment-remove";
    IconNames["Expand"] = "expand";
    IconNames["Export"] = "export";
    IconNames["Favorite"] = "favorite";
    IconNames["Filter"] = "filter";
    IconNames["Headset"] = "headset";
    IconNames["Help"] = "help";
    IconNames["Import"] = "import";
    IconNames["Information"] = "information";
    IconNames["Integration"] = "integration";
    IconNames["Key"] = "key";
    IconNames["Lightning"] = "lightning";
    IconNames["LocationPin"] = "location-pin";
    IconNames["Lock"] = "lock";
    IconNames["Management"] = "management";
    IconNames["Menu"] = "menu";
    IconNames["Monitor"] = "monitor";
    IconNames["NoVisibility"] = "no-visibility";
    IconNames["Notification"] = "notification";
    IconNames["NotificationUrgent"] = "notification-urgent";
    IconNames["NotificationCenter"] = "notification-center";
    IconNames["OrderRequest"] = "order-request";
    IconNames["PaidService"] = "paid-service";
    IconNames["Paperclip"] = "paperclip";
    IconNames["Phone"] = "phone";
    IconNames["Plus"] = "plus";
    IconNames["Port"] = "port";
    IconNames["Power"] = "power";
    IconNames["Reactive"] = "reactive";
    IconNames["Refresh"] = "refresh";
    IconNames["Reject"] = "reject";
    IconNames["RemoteHands"] = "remote-hands";
    IconNames["Renew"] = "renew";
    IconNames["Reorder"] = "reorder";
    IconNames["Resource"] = "resource";
    IconNames["Restart"] = "restart";
    IconNames["RunRequest"] = "run-request";
    IconNames["Save"] = "save";
    IconNames["Search"] = "search";
    IconNames["Selection"] = "selection";
    IconNames["Settings"] = "settings";
    IconNames["Share"] = "share";
    IconNames["ShipmentNotice"] = "shipment-notice";
    IconNames["Sort1"] = "sort1";
    IconNames["Sort2"] = "sort2";
    IconNames["Start"] = "start";
    IconNames["Support"] = "support";
    IconNames["TrendLine"] = "trend-line";
    IconNames["Unlock"] = "unlock";
    IconNames["UserInactive"] = "user-inactive";
    IconNames["UserPlus"] = "user-plus";
    IconNames["User"] = "user";
    IconNames["Video"] = "video";
    IconNames["Visibility"] = "visibility";
    IconNames["WidgetAdd"] = "widget-add";
    IconNames["Wrench"] = "wrench";
    IconNames["Star"] = "star";
    IconNames["Hamburger"] = "hamburger";
    IconNames["Vector"] = "vector";
    IconNames["Union"] = "union";
    IconNames["Connectivity"] = "connectivity";
    IconNames["InternetConnect"] = "internet-connect";
    IconNames["Report"] = "report";
    IconNames["RemoteHandBadge"] = "remote-hands-badge";
    IconNames["ShipmentNoticeBadge"] = "shipment-notice-badge";
    IconNames["Sun"] = "sun";
    IconNames["Night"] = "night";
    IconNames["Temperature"] = "temperature";
    IconNames["EquipmentRemoval"] = "equipment-removal";
    IconNames["VisitorReservation"] = "visitor-reservation";
    IconNames["CriticalContact"] = "critical-contact";
    IconNames["GeneralRequests"] = "GeneralRequests";
    IconNames["clock"] = "clock";
    IconNames["SdpUser"] = "sdp-user";
    IconNames["Rack"] = "rack";
})(IconNames || (IconNames = {}));
